export default "__VITE_ASSET__BepoctBr__"